<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yBp1Ab/images/9781460334591_fmt.jpeg?1689345885294" alt="This image is the cover for the book Never Surrender, Shadow Warriors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Never Surrender, Shadow Warriors
      </h1>
      <p class="bookDescription body article font2">
        <b>“McKenna takes readers on a gritty and emotional journey with this high-octane sequel to <i>Breaking Point</i> . . . will move readers to tears.” —<i>Publishers Weekly</i> (starred review)</b><br/>  <br/> Despite her sweet nature, Navy medic Bay Thorn’s will is unbreakable. It has earned her not only the respect of her team, but also the love of Navy SEAL Gabe Griffin. And as soon as she wraps up the final six months of Operation Shadow Warriors in Afghanistan, she’ll have her happily ever after . . . <br/>  <br/> Until her deployment goes horribly wrong.<br/>  <br/> Bay’s medical expertise is needed by the Taliban, and she is taken hostage. Her captor is ruthless and cruel, and Bay isn’t exempt from his evil intents. All that’s left now is her resolve and the too-distant memory of Gabe—her last and only hope for rescue. And to pull Bay from hell, this SEAL will have to break every rule in the book. But will Gabe find the woman he loves . . . or a woman broken beyond recognition?<br/>  <br/><b>“[A] dynamic black-ops thriller . . . Ms. McKenna masterfully blends the two different paces to convey a beautiful saga about love, trust, patience and having faith in each other.” —<i>Fresh Fiction</i></b><br/>  <br/><b>“McKenna’s expert knowledge of the Navy SEALs gives authenticity to a very tender and heartwrenching story. Filled with non-stop action, <i>Never Surrender</i> grabs at the heart.” —<i>RT Book Reviews</i></b><br/>  <br/><b>“[A] truly memorable story . . . this one has a special, heartbreaking resonance.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsay McKenna
      </h2>
      
      <p class="authorDescription body article">A U.S. Navy veteran, she was a meteorologist while serving her country. She&#160;pioneered the military romance in 1993 with Captive of Fate, Silhouette Special edition.&#160; Her heart and focus is on honoring and showing our military men and women.&#160; Creator of the Wyoming Series and Shadow Warriors series for HQN, she writes emotionally and romantically intense suspense stories. Visit her online at <a href="http://www.LindsayMcKenna.com">www.LindsayMcKenna.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?783683c4